import { render, staticRenderFns } from "./NigeriaMap.vue?vue&type=template&id=20f3f0a4&scoped=true&"
import script from "./NigeriaMap.vue?vue&type=script&lang=js&"
export * from "./NigeriaMap.vue?vue&type=script&lang=js&"
import style0 from "./NigeriaMap.vue?vue&type=style&index=0&id=20f3f0a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f3f0a4",
  null
  
)

export default component.exports